import React from 'react';
import { Helmet } from 'react-helmet';

export interface IMetaDataProps {
  title: string;
  description: string;
  image: string;
}

const MetaData: React.FC<IMetaDataProps> = ({ title, description, image }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:site_name" content="Constellation Agency" />
      <meta name="description" content={title} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};

export default MetaData;
